import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './admin.css';
import logo from '../assets/spartan.png';
import adminPhoto from '../assets/adminphoto.png';
import AddMemberModal from './GymMembers/AddMemberModal';
import { Avatar, Box, Typography, List, ListItem, ListItemIcon, ListItemText, Button, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { FitnessCenter as FitnessCenterIcon, ExpandMore as ExpandMoreIcon, Visibility as VisibilityIcon, PersonAdd as PersonAddIcon } from '@mui/icons-material';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import DeleteIcon from '@mui/icons-material/Delete';
import GymMembers from './GymMembers/GymMembers';
import RecentlyDeleted from './RecentlyDeleted/RecentlyDeleted';
import ExpenseGraph from './ExpenseGraph/ExpenseGraph';

const Sidebar = ({ setActiveComponent, isMobile, setSidebarVisible, visible, openModal }) => {

  const handleItemClick = (component) => {
    if (component === 'AddGymMember') {
      openModal();
    } else {
      setActiveComponent(component);
    }
    if (isMobile) {
      setSidebarVisible(false);
    }
  };

  const sidebarClass = isMobile ? 'sidebar sidebar-mobile' : 'sidebar';
  const sidebarVisibleClass = isMobile && visible ? 'visible' : '';

  return (
    <Box className={`${sidebarClass} ${sidebarVisibleClass} sidebar-scrollbar`}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 2 }}>
        <Avatar src={adminPhoto} sx={{ width: 80, height: 80, border: '2px solid #16213e' }} />
        <Typography variant="h6" sx={{ marginTop: 1, color: '#e94560' }}>
          Meharbaan
        </Typography>
      </Box>
      <List>
        <AccordionSection
          title="Gym Members"
          icon={<FitnessCenterIcon sx={{ color: '#ffffff' }} />}
          items={[
            { text: 'View Gym Members', component: 'ViewGymMembers' },
            { text: 'Add Gym Member', component: 'AddGymMember' },
          ]}
          handleItemClick={handleItemClick}
        />
        <ListItem button onClick={() => handleItemClick('viewDeleted')}>
          <ListItemIcon>
            <DeleteIcon sx={{ color: '#ffffff' }} />
          </ListItemIcon>
          <ListItemText primary="Recently Deleted" />
        </ListItem>
        <ListItem button onClick={() => handleItemClick('ViewExpenses')}>
          <ListItemIcon>
            <CurrencyRupeeIcon sx={{ color: '#ffffff' }} />
          </ListItemIcon>
          <ListItemText primary="Expense Graph" />
        </ListItem>
      </List>
      {isMobile && (
        <Button onClick={() => setSidebarVisible(false)} sx={{ color: '#ffffff', marginTop: 2 }}>
          Close Sidebar
        </Button>
      )}
    </Box>
  );
};

const AccordionSection = ({ title, icon, items, handleItemClick }) => (
  <Accordion sx={{ backgroundColor: 'transparent', color: '#ffffff' }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#ffffff' }} />}>
      <ListItem component="div">
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={title} />
      </ListItem>
    </AccordionSummary>
    <AccordionDetails>
      <List>
        {items.map((item, index) => (
          <ListItem button key={index} onClick={() => handleItemClick(item.component)}>
            <ListItemIcon>
              {item.text === 'Add Gym Member' ? (
                <PersonAddIcon sx={{ color: '#ffffff' }} />
              ) : (
                <VisibilityIcon sx={{ color: '#ffffff' }} />
              )}
            </ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
    </AccordionDetails>
  </Accordion>
);

const ViewGymMembers = () => {
  const [todayMembersCount, setTodayMembersCount] = useState(0);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2 style={{ margin: '0px' }}>Gym Members</h2>
        <div style={{
          backgroundColor: '#6d2057',
          color: 'white',
          padding: '8px 15px',
          borderRadius: '5px',
          fontSize: '14px'
        }}>
          Members Added Today: {todayMembersCount}
        </div>
      </div>
      <GymMembers setTodayMembersCount={setTodayMembersCount} />
    </div>
  );
};

const ViewDeleted = () => (
  <div>
    <h2 style={{ margin: '0px' }}>Recently Deleted Members</h2>
    <RecentlyDeleted />
  </div>
);

const ViewExpenses = () => (
  <div>
    <h2 style={{ margin: '0px' }}>Expense Graph</h2>
    <ExpenseGraph />
  </div>
);

const AddGymMember = () => (
  <div>
    <h2>Add Member</h2>
    <AddMemberModal />
  </div>
);

function AdminDashboard() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [activeComponent, setActiveComponent] = useState('ViewGymMembers');

  useEffect(() => {
    const handleResize = () => {
      const isMobileView = window.innerWidth <= 768;
      setIsMobile(isMobileView);
      setSidebarVisible(false); // Keep sidebar closed by default
    };
    handleResize(); // Call immediately to set initial state
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const toggleMenu = () => setSidebarVisible(!sidebarVisible);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const handleLogout = () => {
    localStorage.removeItem('session');
    window.location.href = '/';
  };

  const renderActiveComponent = () => {
    switch (activeComponent) {
      case 'ViewGymMembers':
        return <ViewGymMembers openModal={openModal} />;
      case 'AddGymMember':
        return <AddGymMember />;
      case 'ViewExpenses':
        return <ViewExpenses />;
      case 'viewDeleted':
        return <ViewDeleted />;
      default:
        return <ViewGymMembers />;
    }
  };

  return (
    <div className="admin-dashboard">
      <nav className="navbar1">
        <div className="navbar1-logo">
          <Link to="/admin-dashboard">
            <img src={logo} alt="Logo" />
          </Link>
        </div>
        <div className="navbar1-search">
          <div className={`hamburger1 ${sidebarVisible ? 'open' : ''}`} onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <ul className={`navbar-options1 ${sidebarVisible ? 'active' : ''}`}>
            <li className="profile-dropdown">
              <img src={adminPhoto} alt="User" onClick={toggleDropdown} />
              {dropdownOpen && (
                <ul className="dropdown-menu">
                  <li>
                    <button onClick={handleLogout}>Logout</button>
                  </li>
                </ul>
              )}
            </li>
          </ul>
        </div>
      </nav>

      <div className="admin-content" style={{ display: 'flex' }}>
        <Sidebar
          setActiveComponent={setActiveComponent}
          isMobile={isMobile}
          setSidebarVisible={setSidebarVisible}
          visible={sidebarVisible}
          openModal={openModal}
        />
        <div style={{ flexGrow: 1, padding: '20px' }}>{renderActiveComponent()}</div>
      </div>
      <AddMemberModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
}

export default AdminDashboard;